import React from "react";

import { Row, Col, Space, Form ,message} from "antd";
import { CPButton, CPInputPassword } from "components/CP";

import {
  close,
  addInformation,
  oldPassword,
  requiredMessage,
  errorMessageNotMatchPassword,
  password,
  passwordConfirm,
} from "lang/fa.json";

const { useForm } = Form;

const Index = ({ loading, onSubmit, onCloseModal }) => {
  const [form] = useForm();
  const [loadingRole, setLoadingRole] = React.useState(false);


  const onFinish = async (data) => {
    onSubmit(data);
  };

  return (
    <div>
      <Form form={form} name="addGroups" onFinish={onFinish} layout="vertical">
        <Row>
          {/* <Col xs={24} sm={12} md={24}>
            <CPInputPassword
              hasValidation
              name={"oldPassword"}
              type={"text"}
              label={oldPassword}
              placeholder={oldPassword}
              rules={[
                {
                  required: true,
                  message: { requiredMessage },
                },
              ]}
            />
          </Col> */}
          <Col xs={24} sm={12} md={24}>
            <CPInputPassword
              hasValidation
              name={"password"}
              type={"text"}
              label={password}
              placeholder={password}
              rules={[
                {
                  required: false,

                },
              ]}
            />
          </Col>

          <Col xs={24} sm={12} md={24}>
            <CPInputPassword
              hasValidation              
              name={"ConfirmPassword"}
              type={"text"}
              label={passwordConfirm}
              placeholder={passwordConfirm}
              rules={[
                {
                  required: false,
                },
              ]}
              //   // ({ getFieldValue }) => ({
              //   //   validator(rule, value) {
              //   //     if (!value || getFieldValue("password") === value) {
              //   //       return Promise.resolve();
              //   //     }
              //   //     else{
              //   //       return Promise.reject(`${errorMessageNotMatchPassword}`);

              //   //     }
              //   //   },
              //   // }),
              // ]}
            />
          </Col>
        </Row>
        <div className="footer-modal">
          <Row>
            <Col span={12}>
              <Space>
                <CPButton type="primary" htmlType="submit" loading={loadingRole}>
                  <span>{addInformation}</span>
                </CPButton>
                <CPButton onClick={onCloseModal} disabled={loadingRole}>
                  {close}
                </CPButton>
              </Space>
            </Col>
          </Row>
        </div>
      </Form>
    </div>
  );
};

export default Index;
